import React from 'react';
import Select from 'react-select';

import {
  PaymentFormEnum,
  PaymentFormEnumText,
} from '../../../common/spdCore/validation/enums';

const options = Object.values(PaymentFormEnum).map(value => ({
  value,
  label: PaymentFormEnumText[value],
}));

interface PaymentFormSelectorProps {
  value: PaymentFormEnum | null | undefined;
  onChange: (value: PaymentFormEnum) => void;
  isDisabled?: boolean;
}

export const PaymentFormSelector: React.FC<PaymentFormSelectorProps> = ({
  value,
  onChange,
  isDisabled,
}) => (
  <Select
    value={options.find(o => o.value === value) ?? null}
    options={options}
    onChange={option => option && onChange(option.value)}
    isDisabled={isDisabled}
  />
);
